export enum TabType {
  OVERVIEW = "overview",
  SURVEY_HISTORY = "survey-history",
  ESCALATION_LOGS = "escalation-logs",
  PROFILE_DETAILS = "profile-details"
}

export enum IconName {
  FEATHER_HOME = "FeatherHome",
  FEATHER_LIST_CHECKS = "FeatherListChecks",
  FEATHER_USER = "FeatherUser",
  FEATHER_PHONE = "FeatherPhone",
  FEATHER_MAIL = "FeatherMail",
  FEATHER_COPY = "FeatherCopy",
  FEATHER_CALENDAR = "FeatherCalendar",
  FEATHER_CLOCK = "FeatherClock",
  FEATHER_FILE_TEXT = "FeatherFileText",
  FEATHER_USERS = "FeatherUsers",
  FEATHER_EDIT = "FeatherEdit",
  FEATHER_CHECK_CIRCLE = "FeatherCheckCircle",
  FEATHER_MEH = "FeatherMeh",
  FEATHER_USER_CIRCLE = "FeatherUserCircle",
  FEATHER_MAP_PIN = "FeatherMapPin",
  FEATHER_GLOBE = "FeatherGlobe",
  FEATHER_BUILDING = "FeatherBuilding",
  FEATHER_BRIEFCASE = "FeatherBriefcase",
  FEATHER_FILE_BAR_CHART = "FeatherFileBarChart"
}

export interface BreadcrumbItem {
  icon: IconName;
  label: string;
  href?: string;
} 